import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAppContext from "../hooks/useAppContext";
import excelIcon from "../images/excel.svg";
import TabNav from "./TabNav";

const Sidebar = ({ open, toggleOpen }) => {
  const { authInfo } = useAppContext();
  const { onLogout } = authInfo;
  const user = JSON.parse(localStorage.getItem("user"));
  const { name, designation } = user;
  const navItems = ["profile", "settings"];
  const [active, setActive] = useState(navItems[0]);
  const navigate = useNavigate();

  const navigateUploads = () => {
    toggleOpen();
    setActive(navItems[0]);
    navigate("admin/Uploads");
  };

  return (
    <>
      <div
        className={`sidebar bg-white w-80 fixed top-0 h-screen shadow-[0_4px_4px_rgba(0,0,0,0.25)] ${
          !open ? "-right-full" : "right-0"
        } z-50 ease-in-out duration-300 px-3 py-2`}
      >
        <div className="sidebar-header">
          <div
            className="sidebar-close relative flex justify-end p-2 cursor-pointer"
            onClick={toggleOpen}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </div>
        {user.role !== "user" ? (
          <>
            <div className="toggle-tabs mb-3">
              <TabNav
                navItems={navItems}
                active={active}
                setActive={setActive}
              />
            </div>
            <div className="tab-content">
              {active === "profile" && (
                <div className="user-info text-center">
                  <div className="image">
                    <svg
                      enableBackground="new -208.5 21 100 100"
                      version="1.1"
                      viewBox="-208.5 21 100 100"
                      className="w-20 h-20 rounded-full mx-auto"
                    >
                      <g>
                        <rect
                          fill="#F5EEE5"
                          height="100"
                          width="100"
                          x="-208.5"
                          y="21"
                        />
                        <path
                          d="M-108.5,121v-14c0,0-21.2-4.9-28-6.7c-2.5-0.7-7-3.3-7-12c0-1.7,0-6.3,0-6.3h-15h-15    c0,0,0,4.6,0,6.3c0,8.7-4.5,11.3-7,12c-6.8,1.9-28.1,7.3-28.1,6.7v14h50.1H-108.5z"
                          fill="#E6C19C"
                        />
                        <g>
                          <defs>
                            <path d="M-108.5,121v-14c0,0-21.2-4.9-28-6.7c-2.5-0.7-7-3.3-7-12c0-1.7,0-6.3,0-6.3h-15h-15c0,0,0,4.6,0,6.3      c0,8.7-4.5,11.3-7,12c-6.8,1.9-28.1,7.3-28.1,6.7v14h50.1H-108.5z" />
                          </defs>
                          <path
                            d="M-158.5,100.1c12.7,0,23-18.6,23-34.4     c0-16.2-10.3-24.7-23-24.7s-23,8.5-23,24.7C-181.5,81.5-171.2,100.1-158.5,100.1z"
                            fill="#D4B08C"
                          />
                        </g>
                        <circle
                          cx="-158.5"
                          cy="71"
                          fill="none"
                          id="Mask_2_"
                          r="50"
                        />
                        <path
                          d="M-158.5,96c12.7,0,23-16.3,23-31c0-15.1-10.3-23-23-23s-23,7.9-23,23    C-181.5,79.7-171.2,96-158.5,96z"
                          fill="#F2CEA5"
                          id="head"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="my-3 capitalize">{name}</div>
                  <div className="my-3 capitalize">{designation}</div>
                  <button
                    className="bg-brand text-white rounded capitalize px-3 py-2"
                    onClick={onLogout}
                  >
                    logout
                  </button>
                </div>
              )}
              {active === "settings" && (
                <div className="settings mt-5">
                  <div className="icon mb-5">
                    <img
                      className="w-16 h-16 mx-auto"
                      src={excelIcon}
                      alt="excelIcon"
                    />
                  </div>
                  <div className="upload">
                    <button
                      className="rounded bg-brand text-white mx-auto flex items-center gap-2 capitalize p-2"
                      onClick={navigateUploads}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                        />
                      </svg>
                      upload
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="user-info text-center">
              <div className="image">
                <svg
                  enableBackground="new -208.5 21 100 100"
                  version="1.1"
                  viewBox="-208.5 21 100 100"
                  className="w-20 h-20 rounded-full mx-auto"
                >
                  <g>
                    <rect
                      fill="#F5EEE5"
                      height="100"
                      width="100"
                      x="-208.5"
                      y="21"
                    />
                    <path
                      d="M-108.5,121v-14c0,0-21.2-4.9-28-6.7c-2.5-0.7-7-3.3-7-12c0-1.7,0-6.3,0-6.3h-15h-15    c0,0,0,4.6,0,6.3c0,8.7-4.5,11.3-7,12c-6.8,1.9-28.1,7.3-28.1,6.7v14h50.1H-108.5z"
                      fill="#E6C19C"
                    />
                    <g>
                      <defs>
                        <path d="M-108.5,121v-14c0,0-21.2-4.9-28-6.7c-2.5-0.7-7-3.3-7-12c0-1.7,0-6.3,0-6.3h-15h-15c0,0,0,4.6,0,6.3      c0,8.7-4.5,11.3-7,12c-6.8,1.9-28.1,7.3-28.1,6.7v14h50.1H-108.5z" />
                      </defs>
                      <path
                        d="M-158.5,100.1c12.7,0,23-18.6,23-34.4     c0-16.2-10.3-24.7-23-24.7s-23,8.5-23,24.7C-181.5,81.5-171.2,100.1-158.5,100.1z"
                        fill="#D4B08C"
                      />
                    </g>
                    <circle
                      cx="-158.5"
                      cy="71"
                      fill="none"
                      id="Mask_2_"
                      r="50"
                    />
                    <path
                      d="M-158.5,96c12.7,0,23-16.3,23-31c0-15.1-10.3-23-23-23s-23,7.9-23,23    C-181.5,79.7-171.2,96-158.5,96z"
                      fill="#F2CEA5"
                      id="head"
                    />
                  </g>
                </svg>
              </div>
              <div className="my-3 capitalize">{name}</div>
              <div className="my-3 capitalize">{designation}</div>
              <button
                className="bg-brand text-white text-sm rounded px-3 py-1 capitalize"
                onClick={onLogout}
              >
                logout
              </button>
            </div>
          </>
        )}
      </div>
      <div
        className={`sidebar-overlay bg-[rgba(0,0,0,0.5)] w-full h-screen absolute inset-0 z-30 ease-in-out duration-300 ${
          !open
            ? "-right-full opacity-0 invisible"
            : "right-0 opacity-100 visible"
        }`}
        onClick={toggleOpen}
      ></div>
    </>
  );
};

export default Sidebar;
